import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function NurseCallIcon(props) {
	return (
		<IconBase type="nurse-call" {...props}>
			<path d="M21.5 2.5H9.5V14.5H10.5V17.5C10.5 19.1569 9.15685 20.5 7.5 20.5C5.84315 20.5 4.5 19.1569 4.5 17.5V14.4146C5.0826 14.2087 5.5 13.6531 5.5 13V6.5H2.5V13C2.5 13.6531 2.9174 14.2087 3.5 14.4146V17.5C3.5 19.7091 5.29086 21.5 7.5 21.5C9.70914 21.5 11.5 19.7091 11.5 17.5V14.5H21.5V2.5ZM20 4V7H16V4H20ZM11 5H12.5V5.5H11V5ZM19.5 9V9.5H16.5V9H19.5ZM11 4H12.5V4.5H11V4ZM19.5 8V8.5H16.5V8H19.5ZM16.5 10H19.5V10.5H16.5V10Z" />
			<path d="M5 5H3V6H5V5Z" />
		</IconBase>
	);
}
NurseCallIcon.propTypes = iconPropTypes;
